import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  bgColor?: 'cream' | 'beige' | 'blush' | 'white' | 'violet';
}
export function Section({
  children,
  className = '',
  id,
  bgColor = 'cream'
}: SectionProps) {
  const bgColors = {
    cream: 'bg-brand-cream',
    beige: 'bg-brand-beige',
    blush: 'bg-brand-blush',
    white: 'bg-white',
    violet: 'bg-brand-violet text-white'
  };
  return <section id={id} className={`${`py-20 md:py-32 ${bgColors[bgColor]} ${className}`} pt-[20px] pb-[20px]`} data-id="element-333">
      <div className="container mx-auto px-4 md:px-8 max-w-6xl" data-id="element-334">{children}</div>
    </section>;
}